import React from 'react';
import {HeroContainer, HeroContent, HeroH1, HeroP} from './HeroElements';
import videoHero from "./../../assets/movies/sphere_v02_black.webm"
import VideoSection from "../VideoSection";
import styled from "styled-components";

const FiftyPercentWidthDiv = styled.div`
  width: 50%;
`
const HeroSection = ({bg}) => {
  return (
    <HeroContainer bg = {bg}>
      <video id="bg-video" autoPlay loop muted>
        <source src={videoHero} type="video/mp4"/>
      </video>
      <HeroContent>
        <div>

          <HeroH1>The BeST NFTs in the MeTAVeRSe Pop BeLLY NFT Collection</HeroH1>
          <HeroP>
            Heroes, villains, innovators, leaders, role models – these are just some of the different
            types of people that have graced our world. This NFT collection offers a wide variety of
            iconic individuals who have been extremely relevant in the world. Now you can own one of them in the form of
            very appealing NFT artwork.
          </HeroP>
        </div>
        <FiftyPercentWidthDiv>
          <VideoSection/></FiftyPercentWidthDiv>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;